export default __webpack_public_path__ + "static/media/RoadRage.03e8327b.ttf";